import { Box } from '@mui/material';
import Typography from '@mui/material/Typography';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import { styles } from '../../style/style';

export default function UserSummary() {

    const userDetails = useSelector((state) => state.user.data.payload);
    var userDisplay = '';
    var userId = '';

    if(userDetails.partnerType === 'FLEET' || userDetails.partnerType === 'FLEETDEALER'){
        userDisplay = 'user.FAN';
        userId = userDetails.primaryFan;
    }else if(userDetails.partnerType === 'DEALER' || userDetails.partnerType === 'UPFITTER'){
        userDisplay = 'user.BAC';
        userId = userDetails.bac;
    }else{
        userDisplay = 'user.ADMINISTRATION';
        userId = userDetails.bac;
    }

    return (
        <Box sx={styles.userSummary}>
            <Box sx={styles.nameAndRole}>
                <Typography id="userName" sx={styles.userName} ><strong>{userDetails.displayName}</strong></Typography>
                <Typography id="userRole" sx={styles.userRole}>{userDetails.partnerType}</Typography>
            </Box>
            <Box sx={styles.companyAndBAC}>
                <Typography id="companyAndBAC" sx={styles.companyAndBAC}><strong><FormattedMessage id={userDisplay} defaultMessage='Business Associated Code (BAC)' />:</strong></Typography>
                <Typography id="userBAC" sx={styles.userBAC}>{userId}</Typography>
            </Box>
        </Box>
    )

}